import { IntegrationStatus, JobOfferChannel } from "../../lib/interfaces/job-offer";

/**
 * Publication channels of a job offer. Mirrors the backend rules
 * (job-offer-channels.ts): a channel counts as switched on while it is live or still
 * being set up, and Google Jobs only lists job offers that are on the career portal.
 */

export const CHANNEL_LABELS: Record<JobOfferChannel, string> = {
  [JobOfferChannel.KLEINANZEIGEN]: "Kleinanzeigen",
  [JobOfferChannel.EXTERNAL_EMBED]: "Karriereportal",
  [JobOfferChannel.GOOGLE_JOBS]: "Google Jobs",
};

/** ACTIVE and PENDING both count as switched on, like in the backend. */
export const isChannelOn = (status: IntegrationStatus | undefined): boolean =>
  status === IntegrationStatus.ACTIVE || status === IntegrationStatus.PENDING;

/** Google Jobs can only be switched on together with the career portal. */
export const canSwitchOnGoogleJobs = (careerPortalOn: boolean): boolean => careerPortalOn;

export const channelRoute = (jobOfferId: string, channel: JobOfferChannel): string =>
  `job-offers/${jobOfferId}/channels/${channel}`;

export interface ActivationChoice {
  kleinanzeigenActive: boolean;
  externalEmbedActive: boolean;
  googleJobsActive: boolean;
}

/** The request body for activating a job offer - never Google Jobs without the career portal. */
export const toActivationBody = (choice: ActivationChoice): ActivationChoice => ({
  ...choice,
  googleJobsActive: choice.googleJobsActive && canSwitchOnGoogleJobs(choice.externalEmbedActive),
});
